import { faFilesMedical } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Mensagem } from '../../../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/Mensagem';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import DefaultButton from '../../Accessibility/DefaultButton';
import DefaultText from '../../Accessibility/DefaultText';
import './styles.css';
import { sxFileButton, sxHoursTextReceived, sxHoursTextSent, sxMessageText } from './sxProps';

const Message: React.FC<{ mensagem: Mensagem; downloadMessageAttachment: () => void; isGC?: boolean }> = ({ mensagem, downloadMessageAttachment, isGC }) => {

  const accessibility = useAccessibility();

  const sentMessage = isGC ? mensagem.direcao === 'C' : !mensagem.isDoctor;
  const messageClass = sentMessage ? 'message-sent' : 'message-received';

  return (
    <div className={`message ${messageClass}`} style={accessibility.buttonStyleAccessibility}>
      {mensagem.indAnexo === 'S' ?
        <DefaultButton variant='text'
          startIcon={<FontAwesomeIcon icon={faFilesMedical} style={accessibility.buttonTextStyleAccessibility} />}
          sx={sxFileButton}
          onClick={downloadMessageAttachment}
        >
          <DefaultText style={accessibility.buttonTextStyleAccessibility} text={mensagem.mensagem} />
        </DefaultButton>
        :
        <>
          <DefaultText style={accessibility.textStyleAccessibility} sx={sxMessageText} text={mensagem.mensagem} />
        </>
      }
      <DefaultText style={accessibility.textStyleAccessibility} sx={sentMessage ? sxHoursTextSent : sxHoursTextReceived} text={mensagem.hrMensagem} />
    </div>
  );
};

export default Message;